import { Container } from 'hypo-container';
import { getDecorators } from '@estee/elc-service';
import { IAppConfig } from '@estee/elc-universal-utils';
import { Config } from '~domain/entities/Config';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { OlapicWidgetViewController } from '~controllers/OlapicWidgetViewController';
import { ProductUgcServiceStartedUseCase } from '~use-cases/ProductUgcServiceStartedUseCase';
import serviceNames, { ProductUgcService } from './ProductUgcService';
import { ConfigStore } from './ConfigStore';

export const diContainer = new Container();

export const setConfig = (configJSON: IAppConfig) => {
    diContainer.config = configJSON;
};

async function serviceInitializer(config: IAppConfig) {
    setConfig(config);

    const useCase = new ProductUgcServiceStartedUseCase([
        'olapicWidgetId',
        'olapicWidgetSrc',
        'olapicInstanceKey',
        'olapicApiKey',
        'olapicLanguage'
    ]);
    await useCase.execute();
}

diContainer
    .register(
        serviceNames.configStore,
        diContainer.factory((c) => new ConfigStore(c.config))
    )
    .register(serviceNames.config, (c) => new Config())
    .register(serviceNames.productUgcService, () => new ProductUgcService(serviceInitializer))
    .register(serviceNames.configRepository, () => new ConfigRepository())
    .register(
        serviceNames.olapicWidgetViewController,
        diContainer.factory((c) => new OlapicWidgetViewController(c.get(serviceNames.config)))
    );

const { lazyInject } = getDecorators(diContainer);

export { lazyInject };
